import styled, { css } from 'styled-components'
import { typography } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { Text } from 'Components/UI/_Legacy'

const darkCss = ({ dark }) =>
  dark &&
  css`
    color: ${themeGet('colors.font.primary')};
  `
const shouldForwardProp = prop => {
  return !['dark'].includes(String(prop))
}

export const SubTitleText = styled(Text).withConfig({
  shouldForwardProp,
})`
  line-height: 150%;
  color: ${themeGet('colors.calculator.textSecondary')};
  font-weight: lighter;

  ${darkCss};

  ${typography};
`
